import React, { PropsWithChildren } from 'react';

interface TableDataProps {
  className?: string;
  colSpan?: number;
  rowSpan?: number;
  style?: any;
}

const TableData = ({
  children,
  className = 'fs-md',
  colSpan,
  rowSpan,
  style,
}: PropsWithChildren<TableDataProps>) => {
  return (
    <td colSpan={colSpan} rowSpan={rowSpan} className={className} style={style}>
      {children}
    </td>
  );
};

export default TableData;
